// Shared table component for watchlist and right panel financials tab
AFRAME.registerComponent('table', {
    schema: {
        data: { type: 'string' },
        width: { default: 3 },
        rowHeight: { default: 0.0125 }, 
        headerColor: { default: '#ffffff' },
        headerBgColor: { default: '#222' },
        rowColor1: { default: '#1a1a1a' },
        rowColor2: { default: '#151515' },
        textColor: { default: '#cccccc' },
        equalColumns: { default: false },
        visibleHeight: { default: 0 },
        positiveColor: { default: '#00ff00' },
        negativeColor: { default: '#ff0000' },
        conditionalColoring: { default: false },
        checkboxColumn: { default: -1 },
        buttonColumn: { default: -1 },
        buttonLabel: { type: 'string', default: 'Edit' },
        columnWidths: { type: 'string', default: '' },
        textScale: { default: 0.03 },
        fontSize: { default: 4 },
        uiButtonFontSize: { default: 0.008 }
    },

    init: function () {
        this.tableData = null;
        this.scrollY = 0;
        this.isDragging = false;
        this.lastDragY = 0;
        this.renderTable();

        this.el.addEventListener('mousedown', this.onMouseDown.bind(this));
        window.addEventListener('mousemove', this.onMouseMove.bind(this));
        window.addEventListener('mouseup', this.onMouseUp.bind(this));

        this.el.addEventListener('triggerdown', this.onMouseDown.bind(this));
        this.el.addEventListener('triggerup', this.onMouseUp.bind(this));
    },

    onMouseDown: function (e) {
        this.isDragging = true;
        this.lastDragY = e.detail.intersection ? e.detail.intersection.point.y : 0;
        if (e.detail.cursorEl) this.raycasterEl = e.detail.cursorEl;
    },

    onMouseUp: function () {
        this.isDragging = false;
        this.raycasterEl = null;
    },

    onMouseMove: function (e) {
        if (!this.isDragging || !this.data.visibleHeight) return;

        let currentY = 0;
        if (this.raycasterEl) {
            const intersection = this.raycasterEl.components.raycaster.getIntersection(this.el);
            if (intersection) {
                currentY = intersection.point.y;
            } else {
                return;
            }
        } else {
            return; 
        }

        const deltaY = currentY - this.lastDragY;
        this.lastDragY = currentY;

        this.scrollY += deltaY;

        const rowCount = this.tableData ? this.tableData.length : 0;
        if (rowCount <= 1) return;
        
        const totalHeight = (rowCount - 1) * this.data.rowHeight;
        const maxScroll = Math.max(0, totalHeight - (this.data.visibleHeight - this.data.rowHeight)); 
        this.scrollY = Math.max(0, Math.min(this.scrollY, maxScroll));

        this.renderTable();
    },

    update: function (oldData) {
        if (this.data.data && typeof this.data.data === 'string') {
            try {
                this.tableData = JSON.parse(this.data.data);
            } catch (e) {
                console.error('table: Failed to parse data:', e);
                this.tableData = null;
            }
        } else if (Array.isArray(this.data.data)) {
            this.tableData = this.data.data;
        }

        if (this.data.data !== oldData.data || (this.tableData && this.tableData !== oldData.data)) {
            this.renderTable();
        }
    },

    renderTable: function () {
        const el = this.el;
        let d = this.tableData || this.data.data;
        const rowHeight = this.data.rowHeight;

        if (typeof d === 'string') {
            try { d = JSON.parse(d); } catch (e) {}
        }
        if (d && typeof d === 'object' && !Array.isArray(d)) {
            if (d.rows && Array.isArray(d.rows)) d = d.rows;
            else if (d.data && Array.isArray(d.data)) d = d.data;
            else d = Object.values(d);
        }

        if (!d || !Array.isArray(d) || d.length === 0) {
            while (el.firstChild) el.removeChild(el.firstChild);
            const placeholder = document.createElement('a-text');
            placeholder.setAttribute('value', 'No data available');
            placeholder.setAttribute('position', '0 0 0.01');
            placeholder.setAttribute('color', '#ffffff');
            placeholder.setAttribute('align', 'center');
            placeholder.setAttribute('anchor', 'center');
            placeholder.setAttribute('scale', `${this.data.textScale} ${this.data.textScale} ${this.data.textScale}`);
            el.appendChild(placeholder);
            return;
        }

        while (el.firstChild) el.removeChild(el.firstChild);

        const dataArray = d;
        const numCols = dataArray[0].length;
        
        let colWidths = [];
        let colXPositions = [];

        if (this.data.columnWidths) {
            const weights = this.data.columnWidths.split(',').map(s => parseFloat(s.trim()));
            const totalWeight = weights.reduce((a, b) => a + b, 0);
            let currentX = -this.data.width / 2;
            for (let i = 0; i < numCols; i++) {
                const w = (weights[i] || 1) / totalWeight * this.data.width;
                colWidths.push(w);
                colXPositions.push(currentX + w / 2);
                currentX += w;
            }
        } else {
            let firstColWidth, otherColWidth;
            if (this.data.equalColumns) {
                firstColWidth = this.data.width / numCols;
                otherColWidth = firstColWidth;
            } else {
                const totalParts = numCols + 1.0;
                const baseColWidth = this.data.width / totalParts;
                firstColWidth = baseColWidth * 2.0;
                otherColWidth = baseColWidth;
            }

            const cellPadding = 0.01;
            let currentX = -this.data.width / 2;
            for (let i = 0; i < numCols; i++) {
                const w = (i === 0) ? firstColWidth : otherColWidth;
                colWidths.push(w);
                colXPositions.push(currentX + (this.data.equalColumns ? w / 2 : (i === 0 ? cellPadding + w / 2 : w / 2)));
                if (i === 0) {
                    colXPositions[i] = this.data.equalColumns ? (currentX + w / 2) : (currentX + cellPadding);
                }
                currentX += w;
            }
        }

        const visibleHeight = this.data.visibleHeight || 999;
        const scrollY = this.scrollY || 0;

        dataArray.forEach((row, rowIndex) => {
            const isHeader = rowIndex === 0;
            const rowY = isHeader ? 0 : ((rowIndex - 1) * -rowHeight + scrollY - rowHeight);
            
            if (!isHeader && this.data.visibleHeight > 0) {
                if (rowY > -rowHeight + 0.001) return;
                if (rowY < -visibleHeight - rowHeight) return;
            }

            row.forEach((cell, colIndex) => {
                const y = rowY;

                if (colIndex === 0) {
                    const bg = document.createElement('a-plane');
                    bg.setAttribute('width', this.data.width);
                    bg.setAttribute('height', rowHeight);
                    bg.setAttribute('position', `0 ${y} 0`);
                    bg.setAttribute(
                        'color',
                        rowIndex === 0 ? this.data.headerBgColor : (rowIndex % 2 === 0 ? this.data.rowColor1 : this.data.rowColor2)
                    );
                    bg.setAttribute('shader', 'flat');
                    el.appendChild(bg);
                }

                const x = colXPositions[colIndex];
                const w = colWidths[colIndex];

                if (this.data.checkboxColumn === colIndex) {
                    const isChecked = !!cell;
                    
                    const checkboxSize = 0.009 * (this.data.textScale / 0.03);
                    const checkboxWidth = 0.025 * (this.data.textScale / 0.03);
                    const checkboxHeight = 0.012 * (this.data.textScale / 0.03);

                    const checkboxBg = document.createElement('a-entity');
                    checkboxBg.setAttribute('geometry', `primitive: plane; width: ${checkboxWidth}; height: ${checkboxHeight}`);
                    checkboxBg.setAttribute('material', 'shader: flat; transparent: true; opacity: 0');
                    checkboxBg.setAttribute('position', `${x} ${y} 0.01`);
                    checkboxBg.setAttribute('data-raycastable', '');
                    checkboxBg.classList.add('clickable');
                    
                    const checkboxBorder = document.createElement('a-plane');
                    checkboxBorder.setAttribute('width', checkboxSize);
                    checkboxBorder.setAttribute('height', checkboxSize);
                    checkboxBorder.setAttribute('color', isChecked ? '#3636E3' : '#555555');
                    checkboxBorder.setAttribute('position', '0 0 0.005');
                    checkboxBorder.setAttribute('shader', 'flat');
                    checkboxBg.appendChild(checkboxBorder);

                    if (isChecked) {
                        const checkIcon = document.createElement('a-image');
                        checkIcon.setAttribute('src', 'vr-assets/check.png');
                        const iconSize = 0.007 * (this.data.textScale / 0.03);
                        checkIcon.setAttribute('width', iconSize);
                        checkIcon.setAttribute('height', iconSize);
                        checkIcon.setAttribute('position', '0 0 0.006');
                        checkIcon.setAttribute('transparent', 'true');
                        checkboxBorder.appendChild(checkIcon);
                    }

                    checkboxBg.addEventListener('click', (evt) => {
                        this.el.emit('table-checkbox-click', { rowIndex: rowIndex, colIndex: colIndex, checked: !isChecked });
                        evt.stopPropagation();
                    });

                    el.appendChild(checkboxBg);

                } else if (this.data.buttonColumn === colIndex && !isHeader) {
                    const btn = document.createElement('a-entity');
                    btn.setAttribute('position', `${x} ${y} 0.01`);
                    btn.setAttribute('ui-button', {
                        label: this.data.buttonLabel,
                        width: w * 0.9,
                        height: rowHeight * 0.8,
                        colorScheme: 'primary',
                        type: 'rounded-box',
                        depth: 0.005 * (this.data.textScale / 0.03),
                        radius: 0.003 * (this.data.textScale / 0.03),
                        preferredFontSize: this.data.uiButtonFontSize
                    });
                    btn.addEventListener('click', (evt) => {
                        this.el.emit('table-button-click', { rowIndex: rowIndex, colIndex: colIndex, data: cell });
                        evt.stopPropagation();
                    });
                    el.appendChild(btn);

                } else {
                    const text = document.createElement('a-text');
                    text.setAttribute('value', cell || '');
                    text.setAttribute('width', this.data.fontSize);

                    let color = rowIndex === 0 ? this.data.headerColor : this.data.textColor;
                    if (this.data.conditionalColoring && !isHeader && cell) {
                        const cleanCell = String(cell).trim();
                        if (cleanCell.startsWith('+')) color = this.data.positiveColor;
                        else if (cleanCell.startsWith('-')) color = this.data.negativeColor;
                    }
                    text.setAttribute('color', color);

                    text.setAttribute('align', this.data.equalColumns ? 'center' : (colIndex === 0 ? 'left' : 'center'));
                    text.setAttribute('anchor', this.data.equalColumns ? 'center' : (colIndex === 0 ? 'left' : 'center'));
                    text.setAttribute('scale', `${this.data.textScale} ${this.data.textScale} ${this.data.textScale}`);

                    text.setAttribute('position', `${x} ${y} 0.01`);
                    el.appendChild(text);
                }
            });
        });
    }
});
